<template>
	<div>

		<!-- The teacher view of a student progress report should include the student name, programme, year and group / firm at the top. -->
		<div v-if="student && showheaders" class="clearfix">
			<div class="float-right">
				<button v-if="$UserSession.hasPriv.call(this, 'REPORT_INDIVIDUAL')" class="btn btn-dark ml-2" @click="$router.push(`/reports/activity/individual/${student.id}`)">{{ $t('activity-report') }}</button>
				<button v-if="isTeacher && $UserSession.hasPriv.call(this, 'REPORT_ANALYSIS')" class="btn btn-dark ml-2" @click="$router.push(`/reports/aggregated/progress/${student.programme}/${student.year}`)">{{ $t('analysis-report') }}</button>
			</div>
			<h1>
				{{ student.displayName }}
				<button v-if="isTeacher" class="btn btn-outline-dark btn-sm" @click="selectStudent()">{{ $t('change') }}</button>
			</h1>
			<ul class="list-inline">
				<li class="list-inline-item">{{ $t('programme-colon') }} {{ $config.getProgrammeNameById(student.programme) }}</li>
				<li class="list-inline-item">{{ $t('year-colon') }} {{ $config.getUserYearStr(student) }}</li>
				<li class="list-inline-item">{{ $t('group-colon') }} {{ $config.getGroupNameById(student.group) }}</li>
				<li class="list-inline-item">{{ $t('firm-colon') }} {{ $config.getFirmNameById(student.firm) }}</li>
			</ul>
		</div>
		<div v-for="(row, rowIndex) in reportconfig.grid" v-bind:key="rowIndex" class="row">
			<div v-for="(col, colIndex) in row" :key="colIndex" v-bind:class="getColClass(col)">
				<div v-for="(datapoint, dIndex) in col.fields" v-bind:key="dIndex">

					<h2 v-if="datapoint.type == 'heading'">{{ datapoint.caption }}</h2>

					<div v-if="datapoint.type == 'bargraphhorizontal'">
						<BarGraphHorizontal
							:settings="datapoint" 
							:student="student" 
							:hideTarget="hideTargets"
							:includeTimeSeries="includeTimeSeries"
                            @display-plot="togglePlot"
						/>
                        <!--b-button v-b-toggle.collapse-test 
                            v-if="includeTimeSeries"
                            variant="primary"
                            @click="togglePlot(datapoint.data)"
                            >
                            {{ $t("plot") }}
                        </b-button-->
                        <b-collapse
                            v-model="visiblePlot[datapoint.data]"
                            :id="`collapse-${datapoint.data}`" 
                            class="mt-2"
                        >
                            <b-card>
                                <TimeSeries 
                                    v-if="datapoint.ready && visiblePlot[datapoint.data]"
                                    :parameters="{
                                        //chartTitle: `${datapoint.caption} for ${student.displayName}`,
                                        student: student,
                                        //dataToPlot: datapoint.data.split('.')[0],
                                        //field: datapoint.data.split('.')[1],
                                        target: datapoint.target,
                                        data: datapoint
                                    }"
                                 />
                            </b-card>
                        </b-collapse>
					</div>

					<div v-if="datapoint.type == 'radialgraphclockwise'">
						<RadialGraphClockwise
							:settings="datapoint"
						/>
					</div>


					<div v-if="datapoint.type == 'datepassed'">
						<DatePassed
							:settings="datapoint"
						/>
					</div>

					<div v-if="datapoint.type == 'upperlowerbargraph'">
						<UpperLowerBarGraph
							:data="getUpperLowerData()"
							:types="getUpperLowerTypes()"
						/>
					</div>

					<div v-if="datapoint.type == 'piechart'">
						<PieChart
							type="donut"
							:settings="datapoint"
						/>
					</div>

					<div v-if="datapoint.type == 'textlist'">
						<TextList
							:settings="datapoint"
						/>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import RadialGraphClockwise from "./RadialGraphClockwise";
import BarGraphHorizontal from "./BarGraphHorizontal";
import UpperLowerBarGraph from "./UpperLowerBarGraph";
import DatePassed from "./DatePassed";
import PieChart from "./PieChart";
import TextList from "./TextList";
import TimeSeries from "./TimeSeries";

export default {
	props: {
		loadedconfig: Object,
		studentid: String,
		selectStudent: null,
		showheaders: {
            type: Boolean,
            default: true,
        },
        hideTargets: {
            type:Boolean,
            default: false
        },
        includeTimeSeries: {
            type:Boolean,
            default: true
        }
	},
	components: {
		RadialGraphClockwise,
		BarGraphHorizontal,
		UpperLowerBarGraph,
		DatePassed,
		PieChart,
		TextList,
		TimeSeries
	},
	data() {
		return {
			reportconfig: {},
			pointers: {},
			reportdata: {},
			graphdata: {},
			student: null,
			chartTitle: 'Plot title',
			dataToPlot: 'treatmentsession',
            visiblePlot:{},
            isLoaded:{}
		};
	},
	mounted() {
		this.getStudentDetails();
		if(this.loadedconfig) {
			this.getReportConfig();
		}
	},
	watch: {
		studentid: function () {
			this.getStudentDetails();
		} ,
		loadedconfig: function () {
			if(this.loadedconfig) {
				this.getReportConfig();
			}
		}
	},
	methods: {
        onShow(data) {
            this.$set(this.isLoaded, data, true);
        },
        togglePlot(caption){
            if(!this.visiblePlot[caption]){ 
                this.visiblePlot[caption] = true;
                return ;
            }
            this.visiblePlot[caption] = !this.visiblePlot[caption]
        },
		getStudentDetails() {
			if(this.studentid){
				this.$users.getUserById.call(this, this.studentid).then(student => {
					this.student = student;
				});
			}
		},
		getColClass(col){
			return 'col-md-' + col.width;
		},
		getReportConfig(){
			this.pointers = {};
			this.reportdata = {};
			this.graphdata = {};
			if('grid' in this.loadedconfig){
				var loadedconfig = JSON.parse(JSON.stringify(this.loadedconfig));
				if(!('filters' in loadedconfig)){
					loadedconfig.filters = {};
				}
				var datapoint = '';
				var itemkey = '';
				for(var row in loadedconfig.grid){
					for(var col in loadedconfig.grid[row]){
						for(var field in loadedconfig.grid[row][col].fields){
							// Data series (pie charts / bar graphs, etc
							if(!('filters' in loadedconfig.grid[row][col].fields[field])){
								loadedconfig.grid[row][col].fields[field].filters = {};
							}
							if(Array.isArray(loadedconfig.grid[row][col].fields[field].data)){
								loadedconfig.grid[row][col].fields[field].ready = false;
								for(var item in loadedconfig.grid[row][col].fields[field].data){
									loadedconfig.grid[row][col].fields[field].data[item].ready = false;
									loadedconfig.grid[row][col].fields[field].data[item].value = 0;
									loadedconfig.grid[row][col].fields[field].data[item].target = 0;
									loadedconfig.grid[row][col].fields[field].data[item].median = 0;
									if(loadedconfig.grid[row][col].fields[field].data[item].data){
										datapoint = loadedconfig.grid[row][col].fields[field].data[item].data.split('.');
										itemkey = datapoint[0]+JSON.stringify(loadedconfig.grid[row][col].fields[field].filters);
										if(!(itemkey in this.pointers)){
											this.pointers[itemkey] = {
												"name": datapoint[0],
												"filters": loadedconfig.grid[row][col].fields[field].filters,
												"pointers": []
											};
										}
										if(!(datapoint[0] in this.pointers)){
											this.pointers[datapoint[0]] = {};
										}
										if(!(datapoint[1] in this.pointers[itemkey].pointers)){
											this.pointers[itemkey].pointers[datapoint[1]] = [];
										}
										this.pointers[itemkey].pointers[datapoint[1]].push({
											'row': row,
											'col': col,
											'field': field,
											'item': item
										});
									}
								}
							} else {
								loadedconfig.grid[row][col].fields[field].ready = false;
								if(field == 'items'){
									loadedconfig.grid[row][col].fields[field].value = [];
								} else {
									loadedconfig.grid[row][col].fields[field].value = 0;
								}
								loadedconfig.grid[row][col].fields[field].target = 0;
								loadedconfig.grid[row][col].fields[field].median = 0;
								if(loadedconfig.grid[row][col].fields[field].data){
									datapoint = loadedconfig.grid[row][col].fields[field].data.split('.');
									itemkey = datapoint[0]+JSON.stringify(loadedconfig.grid[row][col].fields[field].filters);
									if(!(itemkey in this.pointers)){
										this.pointers[itemkey] = {
											"name": datapoint[0],
											"filters": loadedconfig.grid[row][col].fields[field].filters,
											"pointers": []
										};
									}
									if(!(datapoint[1] in this.pointers[itemkey].pointers)){
										this.pointers[itemkey].pointers[datapoint[1]] = [];
									}
									this.pointers[itemkey].pointers[datapoint[1]].push({
										'row': row,
										'col': col,
										'field': field
									});
								}
							}
						}
					}
				}
				this.reportconfig = loadedconfig;
				for(var datasource in this.pointers){
					for(var propname in this.pointers[datasource].pointers){
						this.getReportDataValue(datasource, this.pointers[datasource], propname);					}
				};
			}
		},
		setElementData(data, elementname , name){
			if(elementname in this.pointers){
				for(var property in this.pointers[elementname].pointers){
					if(property == 'items'){
						this.pointers[elementname].pointers[property].forEach((pointer) => {
							if('items' in data.values){
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].value = data.values['items'];
							}
							this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].ready = true;
						});
					} else {
						var value = 0;
						var target = 0;
						var median = 0;
						var quartiles = [];
						if(property in data.values){
							//console.log(property + ': ' + data.values[property]);
							value = data.values[property];
						}
						if(data.targets){
							if(property in data.targets){
								//console.log(property + ': ' + data.targets[property]);
								target = data.targets[property];
							}
						}
						if(data.stats){
							if(property in data.stats){
								//console.log(property + ': ' + data.targets[property]);
								median = data.stats[property].median;
								quartiles[0] = 0;
								quartiles[1] = Number(data.stats[property].q1);
								quartiles[2] = Number(data.stats[property].q2);
								quartiles[3] = Number(data.stats[property].q3);
								quartiles[4] = Number(data.stats[property].q4);
							}
						}
						this.pointers[elementname].pointers[property].forEach((pointer) => {
							if('item' in pointer){
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].data[pointer.item].ready = true;
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].data[pointer.item].value = Number(value);
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].data[pointer.item].target = Number(target);
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].data[pointer.item].median = median;
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].data[pointer.item].quartiles = quartiles;
								if('percentage' in this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].data[pointer.item]){
									if(this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].data[pointer.item].percentage){
										this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].data[pointer.item].percentage = Number(value);
									}
								}
								var allready = true
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].data.forEach(item => {
									if(!item.ready){
										allready = false;
									}
								});
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].ready = allready;
							} else {
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].ready = true;
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].value = Number(value);
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].target = Number(target);
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].median = median;
								this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].quartiles = quartiles;
								if('percentage' in this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field]){
									if(this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].percentage){
										this.reportconfig.grid[pointer.row][pointer.col].fields[pointer.field].percentage = Number(value);
									}
								}
							}
						});
					}
				}
				this.graphdata[elementname] = {
					value: data.values[name],
					stats: data.stats[name]
				};
			}
		},
		getReportDataValue(elementname, datasource , propname){
			if(elementname in this.reportdata){
				this.reportdata[elementname].then((json) => {
					if('retry' in json){
						var self = this;
						window.setTimeout(function(){
							delete self.reportdata[elementname];
							self.getReportDataValue(elementname, datasource , propname);
						} , 2000);
					} else {
						this.setElementData(json.result , elementname , propname);
					}
				});
			} else {
				this.getReportDataElement(elementname, datasource).then((json) => {
					if (json.status === "SUCCESS") {
						if('retry' in json){
							var self = this;
							window.setTimeout(function(){
								delete self.reportdata[elementname];
								self.getReportDataValue(elementname, datasource , propname);
							} , 2000);
						} else {
							this.setElementData(json.result , elementname , propname);
						}
					}
				});
			}
		},
		getReportDataElement(elementname, datasource) {
			const data = {};
			data.filters = Object.assign(this.reportconfig.filters, datasource.filters);
			if(this.studentid) {
				data.student_id = this.studentid;
			}
			this.reportdata[elementname] = this.$cfetch(`${this.$settings.APIBaseURL}/reporting/dataelement/${datasource.name}`, {
				cache: false,
				method: 'post',
				data
			});
			return this.reportdata[elementname];
		},
		getUpperLowerTypes() {
			return [
				{
					name: "Composite",
					color: "#10B981"
				},
				{
					name: "Amalgam",
					color: "#3B82F6"
				},
				{
					name: "GIC",
					color: "#F59E0B"
				}
			];
		},
		getUpperLowerData() {
			return [
				{
					name: "Incisors",
					values: [
						[-2, 4],
						[-9, 8],
						[-1, 10]
					]
				},
				{
					name: "Canines",
					values: [
						[-1, 2],
						[-3, 3],
						[-10, 1]
					]
				},
				{
					name: "Premolars",
					values: [
						[-7, 8],
						[-7, 6],
						[-4, 9]
					]
				},
				{
					name: "Molars",
					values: [
						[-5, 2],
						[-6, 1],
						[-9, 5]
					]
				}
			];
		}
	},
	computed: {
		isTeacher() {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		},
	}
};
</script>
